/*
 *  @providesModule LiveBracketsButtonStyle
 */
import Sizes from 'Sizes';
import {StyleSheet} from 'react-native';
import SkillzStyle from 'SkillzStyle';
import Tournament from 'SKZTournament';
import ClientPropertyConstants from 'ClientPropertyConstants';

const {fontSecondary, fontExtraBold, textColorSecondary, playButtonGradient, tabHighlightColor} =
  SkillzStyle.fullStyles;

const BRACKET_BUTTON_HEIGHT = Sizes.dynamic({
  phone: 45,
  tablet: 68,
});

const BRACKET_BUTTON_WIDTH = Sizes.dynamic({
  phone: 75,
  tablet: 113,
});

const PLAY_BUTTON_SIZES = Sizes.dynamic({
  phone: 45,
  tablet: 68,
});

export const PLAY_BUTTON_ANIMATION = {
  0: {
    opacity: 1,
    scale: 0,
  },
  0.5: {
    opacity: 0.5,
    scale: 0.5,
  },
  0.9: {
    opacity: 0.4,
    scale: 0.9,
  },
  1: {
    opacity: 0,
    scale: 1.3,
  },
};

export const PLAY_BUTTON_ANIMATION_DURATION = 3900;

export const ICON_COLOR = tabHighlightColor.color;

export default StyleSheet.create({
  playButton: {
    ...SkillzStyle.fullStyles.itemsCenter,
    ...SkillzStyle.fullStyles.selfCenter,
    ...SkillzStyle.fullStyles.justifyCenter,
    height: BRACKET_BUTTON_HEIGHT,
    width: BRACKET_BUTTON_WIDTH,
  },

  playButtonContainerLiveBrackets: {
    ...SkillzStyle.fullStyles.flexRow,
    ...SkillzStyle.fullStyles.itemsCenter,
    marginRight: 15,
  },

  playButtonContainerLiveBracketsV2: {
    ...SkillzStyle.fullStyles.flex1,
    ...SkillzStyle.fullStyles.flexCol,
    ...SkillzStyle.fullStyles.itemsCenter,
    ...SkillzStyle.fullStyles.justifyCenter,
  },

  playButtonContainerPlayButtonAdjustment: {
    marginRight: 20,
  },

  playButtonContainerLiveBracketsInFlight: {
    ...SkillzStyle.fullStyles.flexRow,
    ...SkillzStyle.fullStyles.itemsCenter,
  },

  playButtonTextLiveBrackets: {
    ...fontSecondary,
    ...textColorSecondary,
    fontSize: 11,
    ...SkillzStyle.fullStyles.textRight,
    textTransform: 'uppercase',
    marginRight: 2,
    lineHeight: 12,
  },

  playButtonTextLiveBracketsV2: {
    ...fontExtraBold,
    ...textColorSecondary,
    fontSize: 14,
    marginRight: 2,
    lineHeight: 14,
    letterSpacing: -0.42,
    ...SkillzStyle.fullStyles.mt2,
    textTransform: 'capitalize',
    ...SkillzStyle.fullStyles.textCenter,
  },

  playButtonTextLiveBracketsInflight: {
    width: 40,
  },

  playButtonIconLiveBrackets: {
    width: 20,
    height: 20,
    marginLeft: 5,
    ...SkillzStyle.fullStyles.justifyCenter,
    ...SkillzStyle.fullStyles.itemsCenter,
  },

  playButtonAnimation: {
    width: PLAY_BUTTON_SIZES,
    height: PLAY_BUTTON_SIZES,
    borderRadius: PLAY_BUTTON_SIZES / 2,
    position: 'absolute',
  },
});

export function getButtonColor(tournament: Tournament): string[] {
  const hasHostedTournamentCustomColor =
    ClientPropertyConstants.getLiveEventHostedEnabled() && tournament.hasBrandedColor();
  const hostedTournamentCustomColor = tournament.getHostedTournamentCustomColor();

  return hasHostedTournamentCustomColor
    ? [hostedTournamentCustomColor, hostedTournamentCustomColor]
    : playButtonGradient;
}
